import { FC, useState } from "react";
import useI18n from "../../hooks/useTranslations";
import EntityAccessesContent from "./EntityAccessesContent";
import ModalDialog from "./ModalDialog";

interface EntityAccessesDialogProps {
  entityType: string;
  entityId: string;
  entityName?: string;
  onClose: () => void;
}

const EntityAccessesDialog: FC<EntityAccessesDialogProps> = ({ entityType, entityId, entityName, onClose }) => {
  const i18n = useI18n();
  const [isReady, setIsReady] = useState(false);
  const onContentReady = () => setIsReady(true);

  if (!isReady) {
    return (
      <div style={{ display: "none" }}>
        <EntityAccessesContent entityType={entityType} entityId={entityId} onReady={onContentReady} />
      </div>
    );
  }

  return (
    <ModalDialog
      onClose={onClose}
      fitContent
      title={
        entityName ? `${i18n.translation.entityAccesses.title}: ${entityName}` : i18n.translation.entityAccesses.title
      }
    >
      <EntityAccessesContent entityType={entityType} entityId={entityId} onReady={onContentReady} />
    </ModalDialog>
  );
};

export default EntityAccessesDialog;
